import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
import { useNavigate } from "react-router-dom";

const AdminAuditoria = () => {
  const [eventos, setEventos] = useState([]);
  const [eventoSeleccionado, setEventoSeleccionado] = useState("");
  const [eventoInfo, setEventoInfo] = useState(null);
  const [auditoriaData, setAuditoriaData] = useState([]);
  const navigate = useNavigate();
  const [metaEvento, setMetaEvento] = useState(0);
  const [totalAprobadas, setTotalAprobadas] = useState(0);
  const [totalRechazadas, setTotalRechazadas] = useState(0);
  const [totalEvidencias, setTotalEvidencias] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const totalPages = Math.ceil(auditoriaData.length / rowsPerPage);


  //  Obtener eventos al cargar la página
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Eventos/ListaEventos`);
        setEventos(response.data);
      } catch (error) {
        console.error("❌ Error al obtener eventos:", error);
      }
    };

    fetchEventos();
  }, []);

  //  Obtener datos de auditoría cuando se selecciona un evento
  const handleEventoChange = async (e) => {
    const eventoId = Number(e.target.value);
    setEventoSeleccionado(eventoId);

    if (!eventoId) {
      setEventoInfo(null);
      setAuditoriaData([]);
    return;
    }

    try {
      //  Obtener información detallada del evento
      const eventoData = eventos.find(evento => evento.id === eventoId);
      setEventoInfo(eventoData);
      const response = await axios.get(`${API_BASE_URL}/Eventos/AdminAuditoriaPorEvento`, { params: { eventoId }});
      setAuditoriaData(response.data.auditoriaEvento);
      setMetaEvento(response.data.metaEvento || 0);
      setTotalAprobadas(response.data.aprobadas || 0);
      setTotalRechazadas(response.data.rechazadas || 0);
      setTotalEvidencias(response.data.evidencias || 0);
    } catch (error) {
      console.error("❌ Error al obtener auditoría:", error);
      setAuditoriaData([]);
    }
  };
      const indexOfLastRow = currentPage * rowsPerPage;
      const indexOfFirstRow = indexOfLastRow - rowsPerPage;
      const currentRows = auditoriaData.slice(indexOfFirstRow, indexOfLastRow);

      //const paginate = pageNumber => setCurrentPage(pageNumber);

  return (
    <div className=" w-full max-w-4xl mx-auto lg:max-w-4xl xl:max-w-6xl p-6">

    <div className="bg-[#081b29] p-4 flex items-center justify-between">
      {/* Logo y Título juntos en el lado izquierdo */}
      <div className="flex items-center space-x-4">
        <img src="/img/monytorlogoa.png" alt="Logo" className="w=32 h-32" />
        <h2 className="text-white text-3xl font-bold">Auditoría de Eventos</h2>
      </div>

      {/* Botón en el lado derecho */}
      <button
      className="btn text-white font-bold py-1 px-2 rounded"
      style={{ width: '180px' }}  // Ancho fijo
      onClick={() => navigate("/admin/menu")}
    >
        Menú
      </button>
    </div>


      {/*  Selección de evento */}
      <div className="w-full max-width">
        <label className="block text-gray-400 text-sm">Selecciona un Evento</label>
        <select
          className="w-full p-2 border border-gray-600 rounded bg-gray-800 text-white"
          value={eventoSeleccionado}
          onChange={handleEventoChange}
        >
          <option value="">-- Seleccionar Evento --</option>
          {eventos.map((evento) => (
            <option key={evento.id} value={evento.id}>
              {evento.nombreEvento}
            </option>
          ))}
        </select>
      </div>

      {/*  Mostrar detalles del evento */}
      {eventoInfo && (
        <div className="mt-4 bg-[#081b29] p-4 rounded-lg border border-gray-700 text-white shadow-md w-full">
            <h3 className="text-lg font-semibold mb-2 text-center">Detalles del Evento</h3>
          <table className="min-w-full">
            <tbody>
              <tr className="border-b border-gray-600">
                <td className="px-2 py-1 font-semibold">Nombre:</td>
                <td>{eventoInfo.nombreEvento}</td>
              </tr>
              <tr className="border-b border-gray-600">
                <td className="px-2 py-1 font-semibold">Fecha Inicio:</td>
                <td>{eventoInfo.fechaInicio}</td>
              </tr>
              <tr className="border-b border-gray-600">
                <td className="px-2 py-1 font-semibold">Fecha Fin:</td>
                <td>{eventoInfo.fechaFin}</td>
              </tr>
              <tr className="border-b border-gray-600">
                <td className="px-2 py-1 font-semibold">Estatus:</td>
                <td>{eventoInfo.estatusEvento}</td>
              </tr>
              <tr className="border-b border-gray-600">
                <td className="px-2 py-1 font-semibold">Meta:</td>
                <td>{eventoInfo.meta || "Sin meta"}</td>
              </tr>
              <tr className="border-b border-gray-600">
                <td className="px-2 py-1 font-semibold">Descripción:</td>
                <td>{eventoInfo.descripcionEvento || "Sin descripción"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      <br></br>
      {/*  Resumen de Auditoría */}
      {eventoSeleccionado && (
        <div className="bg-[#081b29] p-4 rounded-lg border border-gray-700 text-white shadow-md w-full">
          <h3 className="text-lg font-semibold text-center">Resumen de Auditoría</h3>
          <div className="flex justify-around mt-2">
            <span className="text-yellow-400">📊 Meta del Evento: {metaEvento}</span>
            <span className="text-green-400">✅ Aprobadas: {totalAprobadas}</span>
            <span className="text-red-400">❌ Rechazadas: {totalRechazadas}</span>
            <span className="text-blue-400">📸 Total Evidencias: {totalEvidencias}</span>
          </div>
        </div>
      )}


       {/* Paginación de la tabla de auditoría */}

        {/* Siempre mostrar la tabla de auditoría */}
<>
  <div className="w-full max- overflow-x-auto mt-6">
    <h3 className="text-lg font-semibold text-white text-center mb-4">Resumen de Auditoría</h3>
    <table className="w-full bg-[#081b29] border border-gray-700 text-white rounded-lg">
      <thead>
        <tr className="bg-[#0f283a] text-white">
          <th className="px-6 py-3 border border-gray-700">Nivel</th>
          <th className="px-6 py-3 border border-gray-700">Nombre del Líder</th>
          <th className="px-6 py-3 border border-gray-700">Total Evidencias</th>
          <th className="px-6 py-3 border border-gray-700">Pendientes por validar</th>
          <th className="px-6 py-3 border border-gray-700">Aprobadas</th>
          <th className="px-6 py-3 border border-gray-700">Rechazadas</th>
        </tr>
      </thead>
      <tbody>
        {auditoriaData.length > 0 ? (
          currentRows.map((item, index) => (
            <tr key={index} className="text-center border border-gray-700 hover:bg-[#12394d] transition">
              <td className="px-6 py-3 border border-gray-700">{item.nivel}</td>
              <td className="px-6 py-3 border border-gray-700">{item.nombreLider}</td>
              <td className="px-6 py-3 border border-gray-700">{item.totalEvidencias}</td>
              <td className="px-6 py-3 border border-gray-700">{item.pendientes}</td>
              <td className="px-6 py-3 border border-gray-700 text-green-400">{item.aprobadas}</td>
              <td className="px-6 py-3 border border-gray-700 text-red-400">{item.rechazadas}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6" className="text-center py-3">No hay datos de auditoría para este evento.</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
  <div className="flex justify-center space-x-2 mt-4">
    <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
        ◀ Anterior
      </button>
      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          onClick={() => setCurrentPage(index + 1)}
          className={`px-4 py-2 rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300 text-black'}`}
        >
          {index + 1}
        </button>
      ))}
      <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage >= totalPages}>
        Siguiente ▶
      </button>
  </div>
</>


      {/*  Mensaje si no hay datos
      {eventoSeleccionado && auditoriaData.length === 0 && (

        <p className="text-gray-400 text-center">
         <br /> No hay datos de auditoría para este evento.</p>
      )}
         */}

    </div>
  );
};

export default AdminAuditoria;
